import { AppLayout } from "@/components/layout/AppLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MessageTemplatesTab } from "@/components/user-management/MessageTemplatesTab";
import SurveyManager from "@/components/communication/SurveyManager";
import MeetingRoom from "@/components/communication/MeetingRoom";

const Communication = () => {
  return (
    <AppLayout>
      <div className="space-y-3 sm:space-y-4">
        <div className="page-header">
          <div>
            <h1>Communication</h1>
            <p className="text-muted-foreground text-xs sm:text-sm">Manage SMS templates, surveys, meetings, and communication settings</p>
          </div>
        </div>

        <Tabs defaultValue="templates">
          <TabsList className="w-full sm:w-auto grid grid-cols-3 sm:inline-flex">
            <TabsTrigger value="templates" className="text-xs sm:text-sm">SMS Templates</TabsTrigger>
            <TabsTrigger value="surveys" className="text-xs sm:text-sm">Surveys</TabsTrigger>
            <TabsTrigger value="meetings" className="text-xs sm:text-sm">Meeting Room</TabsTrigger>
          </TabsList>

          <TabsContent value="templates" className="space-y-4">
            <MessageTemplatesTab />
          </TabsContent>

          <TabsContent value="surveys" className="space-y-4">
            <SurveyManager />
          </TabsContent>

          <TabsContent value="meetings" className="space-y-4">
            <MeetingRoom />
          </TabsContent>
        </Tabs>
      </div>
    </AppLayout>
  );
};

export default Communication;
